import React, { useEffect, useState, useMemo } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'
import styles from '../index.module.css'
import { useNavigate } from 'react-router-dom';
import { transmitRequestSelector, checkedResultIndustriesSelector, certFromState, selectedOrgsState } from '../states'
import { manageCheckedResultIndsState, manageCheckedResultState, consentListState } from 'views/mydata/manage/states'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import Lib from 'library'

const DataDetailTerms1 = () => {

	const App = useApp()
	const navigate = useNavigate()
	const [transmitRequest, setTransmitRequest] = useRecoilState(transmitRequestSelector)
	const certFrom = useRecoilValue(certFromState)
	const industries = useRecoilValue(certFrom === "extend" || certFrom === "modify" ? manageCheckedResultIndsState : checkedResultIndustriesSelector)
	const setSelectedOrgs = useSetRecoilState(selectedOrgsState)


	// const oneYearLater = useMemo(() => {
	// 	const oneYear = new Date()
	// 	oneYear.setFullYear(oneYear.getFullYear() + 1)
	// 	oneYear.setDate(oneYear.getDate() - 1)
	// 	return Lib.dateFormat(oneYear)
	// })
	// const [today, setToday] = useState(() => {
	// 	const today = new Date()
	// 	return Lib.dateFormat(today)
	// })
	const [buttonDisabled, setButtonDisabled] = useState(true)

	const extendResult = useRecoilValue(manageCheckedResultState)
	const [consentList, setConsentList] = useRecoilState(consentListState)


	const [cycleList, setCycleList] = useState([])
	const [termsList, setTermasList] = useState([])

	const onNext = () => {
		if (certFrom === "extend" || certFrom === "modify") {
			setSelectedOrgs(consentList.map(item => ({
				insttCd: item.insttCd,
				insttNm: item.insttNm,
				indstCd: item.indstCd,
				targetInfoList: item.targetInfoList
			})))
		}
		navigate("/data/dataDetailTerms2")
	}

	const getExtendConsents = async () => {
		const array = []
		extendResult.forEach(item => {
			array.push(new Promise(resolve => {
				Lib.get(`/api/lnkup/data/mgmt/${item.reqCd}/consents`, data => {
					resolve(data)
				})
			}))
		})
		const result = await Promise.all(array)
		console.log({ result })
		setConsentList(result)
	}
	const getSendCoCode = async () => {
		// 전송주기
		Lib.get('/api/comm/cd/SEND_CYCLE', data => {
			// 전송요구 여부 디폴트 '예'
			if (certFrom !== "extend") {
				setTransmitRequest({
					isScheduled: true
				})
			}
			setCycleList(data);
		})
		// 전송기간
		Lib.get('/api/comm/cd/SEND_TERMS', data => {
			console.log(data)
			setTermasList(data)
		})
	}

	useEffect(() => {
		if (transmitRequest) {
			let count = 0, max = 3
			if (industries.indexOf("efin") > -1) {
				max += 3
			} else {
				if (industries.indexOf("bank") > -1) max += 1
				if (industries.indexOf("card") > -1 || industries.indexOf("telecom") > -1 || industries.indexOf("pcard") > -1) max += 1
			}
			for (let item in transmitRequest) {
				if (typeof transmitRequest[item] !== "undefined") count++
			}

			// 정기적 전송 x + 주기 선택 안 하는게 당연함, count 추가하기
			if (transmitRequest['isScheduled'] === false && typeof transmitRequest['isCycle'] === "undefined") count++
			setButtonDisabled(count < max)
			console.log({ transmitRequest })
		}
	}, [transmitRequest])

	/* useEffect(() => {
		if (transmitRequest.endDate) {
			console.log({ oneYearLater })
			let isOneyear
			if (transmitRequest.endDate === oneYearLater) {
				isOneyear = true
			} else {
				isOneyear = false
			}
			setTransmitRequest(prev => ({
				...prev,
				isOneyear: isOneyear
			}))
		}
	}, [transmitRequest.endDate]) */

	useEffect(() => {
		if (consentList && certFrom !== "modify") {
			setTransmitRequest({
				isScheduled: consentList[0].rglrTrnspYn === "Y" && true || consentList[0].rglrTrnspYn === "N" && false,
				category: consentList[0].prodBuyInfAgreeYn === "Y" && true || consentList[0].prodBuyInfAgreeYn === "N" && false,
				memo: consentList[0].tradeMemoAgreeYn === "Y" && true || consentList[0].tradeMemoAgreeYn === "N" && false,
				regno: consentList[0].mbbsNmInfAgreeYn === "Y" && true || consentList[0].mbbsNmInfAgreeYn === "N" && false
			})
		}
	}, [consentList])

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		if (certFrom === "extend") {
			getExtendConsents()
		}
		getSendCoCode()

		console.log({ industries })
		console.log({ consentList })
		console.log({ transmitRequest })
		console.log({ certFrom })

	}, [])

	return (
		<div className="page">
			<div className="padding flex_1">
				<div className={styles["count-group"]}>
					<p>전송요구 및 정보 제공 동의</p>
					<div><span>2</span>/3</div>
				</div>
				<div className={`${styles["terms-area"]} mt_40`}>

					<p>상세정보 전송요구서 및 개인(신용) 정보 수집 ・ 이용 동의서(상세정보전송)</p>
					<ul className="mt_40">
						<li>
							<div>정기적 전송 요구 여부 및 주기(주/1회)</div>
							<div className="flex-align_center mt_15">
								<div className="chk flex--item_1 flex-align_center" onClick={e => {
									if (certFrom === "extend") return
									setTransmitRequest({
										isScheduled: false,
										isCycle: undefined,
									})
								}}>
									<span className={`mr_10 checkMark${transmitRequest.isScheduled === false ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
									<span>아니오</span>
								</div>
								<div className="chk flex--item_1 flex-align_center" onClick={e => {
									if (certFrom === "extend") return
									setTransmitRequest({
										isScheduled: true,
									})
								}}>
									<span className={`mr_10 checkMark${transmitRequest.isScheduled === true ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
									<span>예</span>
								</div>
							</div>

							{cycleList.length > 0 &&
								transmitRequest.isScheduled === true &&
								<ul className="opt-menu mt_10">
									{cycleList.map((item, index) => {
										return <li key={index} className={transmitRequest.isCycle == item.commCd ? 'active' : ''} onClick={e => {
											if (certFrom === "extend") return
											setTransmitRequest({
												isCycle: item.commCd
											})
										}}>{item.commNm}</li>
									})}
								</ul>
							}
						</li>
						<li>
							<div>전송요구의 종료시점</div>
							{termsList.length > 0 &&
								<div className="flex-align_center mt_15">
									{termsList.map((item, index) => {
										return <div key={index} className="chk flex--item_1 flex-align_center" onClick={e => {
											if (certFrom === "extend") return
											setTransmitRequest({
												endTerms: item.commCd
											})
										}}>
											<span className={`mr_10 checkMark${transmitRequest.endTerms === item.commCd ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
											<span>{item.commNm}</span>
										</div>
									})}
								</div>
							}
						</li>
					</ul>
					{
						(industries.indexOf("bank") > -1 || industries.indexOf("card") > -1 || industries.indexOf("efin") > -1 || industries.indexOf("telecom") > -1 || industries.indexOf("pcard") > -1) &&
						<p className="mt_40">선택항목</p>
					}
					<ul className="mt_10">
						{
							(industries.indexOf("bank") > -1 || industries.indexOf("efin") > -1) &&
							<li>
								<div>적요 또는 거래메모 정보</div>
								{
									(certFrom !== "extend" || (consentList && consentList.length === 1))
										?
										<>
											<span className="mt_10">
												거래내역의 적요 또는 거래메모 정보에는 송금인/수취인명 정보 등 본인의 사생활 및 경제활동 등에 관련된 상세한 정보가 포함되어 있습니다. 정보 전송은 본인의 책임과 판단하에 신중하게 결정하여 주시기 바랍니다.
											</span>
											<div className="flex-align_center mt_15">
												<div className="chk flex--item_1 flex-align_center" onClick={e => {
													if (certFrom === "extend") return
													setTransmitRequest({
														memo: false
													})
												}}>
													<span className={`mr_10 checkMark${transmitRequest.memo === false ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
													<span>수집 미동의</span>
												</div>
												<div className="chk flex--item_1 flex-align_center" onClick={e => {
													if (certFrom === "extend") return
													setTransmitRequest({
														memo: true
													})
												}}>
													<span className={`mr_10 checkMark${transmitRequest.memo === true ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
													<span>수집 동의</span>
												</div>
											</div>
										</>
										:
										<table className="inTable w_100 mt_10">
											<colgroup>
												<col style={{ width: "50%" }} />
												<col style={{ width: "50%" }} />
											</colgroup>
											<tbody>
												{
													consentList && consentList.map((item, index) => {
														if (/bank|efin/.test(item.indstCd)) {
															return (
																<tr key={index}>
																	<th>{item.insttNm}</th>
																	<td>{item.tradeMemoAgreeYn === "Y" ? "동의" : "미동의"}</td>
																</tr>
															)
														}
													})
												}
											</tbody>
										</table>
								}
							</li>
						}
						{
							(industries.indexOf("card") > -1 || industries.indexOf("efin") > -1 || industries.indexOf("telecom") > -1 || industries.indexOf("pcard") > -1) &&
							<li>
								<div>가맹점명 및 사업자등록번호 정보</div>
								{
									(certFrom !== "extend" || (consentList && consentList.length === 1))
										?
										<>
											<span className="mt_10">
												거래(결제)내역의 가맹점 및 사업자등록번호 정보에는 본인의 소비생활 등에 관련된 상세한 정보가 포함되어 있습니다. 정보 전송은 본인의 책임과 판단하에 신중하게 결정하여 주시기 바랍니다.
											</span>
											<div className="flex-align_center mt_15">
												<div className="chk flex--item_1 flex-align_center" onClick={e => {
													if (certFrom === "extend") return
													setTransmitRequest({
														regno: false
													})
												}}>
													<span className={`mr_10 checkMark${transmitRequest.regno === false ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
													<span>수집 미동의</span>
												</div>
												<div className="chk flex--item_1 flex-align_center" onClick={e => {
													if (certFrom === "extend") return
													setTransmitRequest({
														regno: true
													})
												}}>
													<span className={`mr_10 checkMark${transmitRequest.regno === true ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
													<span>수집 동의</span>
												</div>
											</div>
										</>
										:
										<table className="inTable w_100 mt_10">
											<colgroup>
												<col style={{ width: "50%" }} />
												<col style={{ width: "50%" }} />
											</colgroup>
											<tbody>
												{
													consentList && consentList.map((item, index) => {
														if (/card|efin|telecom|pcard/.test(item.indstCd)) {
															return (
																<tr key={index}>
																	<th>{item.insttNm}</th>
																	<td>{item.mbbsNmInfAgreeYn === "Y" ? "동의" : "미동의"}</td>
																</tr>
															)
														}
													})
												}
											</tbody>
										</table>
								}
							</li>
						}

						{
							industries.indexOf("efin") > -1 &&
							<li>
								<div>상품구매정보</div>
								{
									(certFrom !== "extend" || (consentList && consentList.length === 1))
										?
										<>
											<span className="mt_10">
												거래(결제)내역의 상품구매정보에는 실제 구매한 상품이 아닌 해당 상품의 카테고리(13 항목으로 구분)가 포함되어 있습니다. 정보 전송은 본인의 책임과 판단하에 신중하게 결정하여 주시기 바랍니다.
											</span>
											<div className="flex-align_center mt_15">
												<div className="chk flex--item_1 flex-align_center" onClick={e => {
													if (certFrom === "extend") return
													setTransmitRequest({
														category: false
													})
												}}>
													<span className={`mr_10 checkMark${transmitRequest.category === false ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
													<span>수집 미동의</span>
												</div>
												<div className="chk flex--item_1 flex-align_center" onClick={e => {
													if (certFrom === "extend") return
													setTransmitRequest({
														category: true
													})
												}}>
													<span className={`mr_10 checkMark${transmitRequest.category === true ? " on" : ""}${certFrom === "extend" ? " readOnly" : ""}`} />
													<span>수집 동의</span>
												</div>
											</div>
										</>
										:
										<table className="inTable w_100 mt_10">
											<colgroup>
												<col style={{ width: "50%" }} />
												<col style={{ width: "50%" }} />
											</colgroup>
											<tbody>
												{
													consentList && consentList.map((item, index) => {
														if (/efin/.test(item.indstCd)) {
															return (
																<tr key={index}>
																	<th>{item.insttNm}</th>
																	<td>{item.prodBuyInfAgreeYn === "Y" ? "동의" : "미동의"}</td>
																</tr>
															)
														}
													})
												}
											</tbody>
										</table>
								}
							</li>
						}
					</ul>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={onNext} disabled={buttonDisabled}>다음</Button>
			</div>
		</div >
	)
}

export default DataDetailTerms1